<template>
  <div>
    <el-dialog
      title="Selección de Calendario"
      :visible="calendarSelectDialogVisible"
      @update:visible="handleClose($event)"
      width="30%"
    >
      <el-col class="text-center" :span="24">
        <el-form :model="form" :rules="rules" ref="calendarSelectForm">
          <el-form-item
            label="Selecciona un calendario"
            prop="selectedCalendarID"
          >
            <el-select
              v-model="form.selectedCalendarID"
              placeholder="Selecciona un calendario"
              size="small"
            >
              <el-option
                v-for="item in calendars"
                :key="item.ID"
                :label="item.Title"
                :value="item.ID"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose(false)">Cancelar</el-button>
        <el-button type="primary" @click="handleConfirm">Confirmar</el-button>
      </span>
    </el-dialog>

    <!-- Event Create Dialog -->
    <CalendarEventForm
      @close-event-dialog="closeEventDialog"
      :currentChosenCalendarID="currentChosenCalendarID"
      submitMode="Agregar"
      :dialogFormVisible="eventDialogFormVisible"
      :prospect="prospect"
      :contact="contact"
      :Client="Client"
      :Descripcion="Descripcion"
      :Type="true"
      :TipoAgenda="tipoAgenda"
      :DealsId="DealsId"
      :sellerName="sellerName"
    />
  </div>
</template>

<script>
import CalendarEventForm from "@/components/calendar/CalendarEventForm.vue";

export default {
  name: "CalendarSelectDialog",
  components: {
    CalendarEventForm
  },
  props: {
    calendars: {
      type: Array
    },
    calendarSelectDialogVisible: {
      type: Boolean
    },
    contact: {
      type: String
    },
    prospect: {
      type: String
    },
    Client: {
      type: String
    },
    Descripcion: {
      type: String
    },
    DealsId: {
      type: Number
    },
    tipoAgenda: {
      type: Number,
      default: 0
    },
    openNextDialog: {
      type: Boolean,
      default: false
    },
    sellerName: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      eventDialogFormVisible: false,
      currentChosenCalendarID: 0,
      form: {
        selectedCalendarID: null
      },
      rules: {
        selectedCalendarID: [
          {
            required: true,
            message: "Debe seleccionar un calendario",
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    closeEventDialog() {
      this.eventDialogFormVisible = false;
      this.$refs["calendarSelectForm"].resetFields();
    },
    handleConfirm() {
      this.$refs["calendarSelectForm"].validate((valid) => {
        if (valid) {
          this.currentChosenCalendarID = this.form.selectedCalendarID;
          this.eventDialogFormVisible = true; // Open event create form
          this.$emit("update:calendarSelectDialogVisible", false); // Close the dialog
        } else {
          return false;
        }
      });
    },
    handleClose(event) {
      this.$emit("update:calendarSelectDialogVisible", event);
      this.$refs["calendarSelectForm"].resetFields();
    }
  },

  watch: {
    calendars() {
      this.form.selectedCalendarID = this.calendars[0].ID;
    },
    openNextDialog(newVal) {
      if (newVal) {
        this.currentChosenCalendarID = this.form.selectedCalendarID;
        this.eventDialogFormVisible = true;
      }
    }
  }
};
</script>
